import { DOCUMENTS, FIELDS, type AgencyOnboardingSubmission } from "./consultant-agency-us.config.ts";
import styles from "./consultant-agency-us.module.css";

export function AgencyReviewStep({ consultant, documents }: AgencyOnboardingSubmission) {
  return (
    <div className={styles.stack}>
      <section>
        <h3 className="heading-sm mb-3">Consultant Information</h3>
        <dl className={styles.grid}>
          {FIELDS.map(({ key, label }) => <div className={styles.detail} key={key}><dt className="body-sm text-accent">{label}</dt><dd className="body-sm">{consultant[key] || "Not provided"}</dd></div>)}
        </dl>
      </section>
      <section>
        <h3 className="heading-sm mb-3">Agency Documentation</h3>
        <dl className={styles.grid}>
          {DOCUMENTS.map(({ id, label }) => <div className={styles.detail} key={id}><dt className="body-sm text-accent">{label}</dt><dd className="body-sm">{documents[id]?.name || "Not attached"}</dd></div>)}
        </dl>
      </section>
    </div>
  );
}
